import React from "react";
import UrlHelper from "../../utilities/UrlHelper";

const Logo =()=>{
    return (
        <img className="logo"
            src={UrlHelper.getIdentifiUrl() +"img/wk-brand.svg"}/>
    );
};

export default Logo;

